import * as i0 from '@angular/core';
import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
const _c0 = ["icon"];
class IDIconBase {
  cdr;
  hostElement;
  title = "";
  colorpreset = -1;
  color = "";
  color2 = "";
  size = "m";
  width = "";
  height = "";
  rotate = "";
  inline = false;
  tabindex = null;
  icon;
  hasViewInitiated = false;
  constructor(cdr, hostElement) {
    this.cdr = cdr;
    this.hostElement = hostElement;
  }
  ngAfterViewInit() {
    this.hasViewInitiated = true;
    this.setupProperties();
  }
  ngOnChanges() {
    if (this.hasViewInitiated) {
      this.setupProperties();
    }
  }
  setupProperties() {
    const el = this.icon.nativeElement;
    if (this.title) {
      el.setAttribute("title", this.title);
    }
    if (this.colorpreset) {
      el.setAttribute("colorpreset", this.colorpreset);
      el.colorpreset = this.colorpreset;
    }
    if (this.size) {
      el.setAttribute("size", this.size);
    }
    if (this.color) {
      el.setAttribute("color", this.color);
    }
    if (this.color2) {
      el.setAttribute("color2", this.color2);
    }
    if (this.width) {
      el.setAttribute("width", this.width);
    }
    if (this.height) {
      el.setAttribute("height", this.height);
    }
    if (this.rotate) {
      el.setAttribute("rotate", this.rotate);
    }
    if (this.inline) {
      el.setAttribute("inline", this.inline);
    }
    if (this.tabindex !== null) {
      el.setAttribute("tabindex", this.tabindex);
    }
  }
  static ɵfac = function IDIconBase_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IDIconBase)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IDIconBase,
    selectors: [["ng-component"]],
    viewQuery: function IDIconBase_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.icon = _t.first);
      }
    },
    hostAttrs: [1, "ids-contains-icon"],
    inputs: {
      title: "title",
      colorpreset: "colorpreset",
      color: "color",
      color2: "color2",
      size: "size",
      width: "width",
      height: "height",
      rotate: "rotate",
      inline: "inline",
      tabindex: "tabindex"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 0,
    vars: 0,
    template: function IDIconBase_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IDIconBase, [{
    type: Component,
    args: [{
      template: "",
      host: {
        class: "ids-contains-icon"
      }
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }], {
    title: [{
      type: Input
    }],
    colorpreset: [{
      type: Input
    }],
    color: [{
      type: Input
    }],
    color2: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    width: [{
      type: Input
    }],
    height: [{
      type: Input
    }],
    rotate: [{
      type: Input
    }],
    inline: [{
      type: Input
    }],
    tabindex: [{
      type: Input
    }],
    icon: [{
      type: ViewChild,
      args: ["icon"]
    }]
  });
})();
class IDFormBase {
  invalid = false;
  light = false;
  novalidation = false;
  onValid = new EventEmitter();
  onInvalid = new EventEmitter();
  invalidChange = new EventEmitter();
  emitOnValid(event) {
    this.invalid = false;
    this.onValid.emit(event);
    this.invalidChange.emit(this.invalid);
  }
  emitOnInvalid(event) {
    this.invalid = true;
    this.onInvalid.emit(event);
    this.invalidChange.emit(this.invalid);
  }
  static ɵfac = function IDFormBase_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IDFormBase)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IDFormBase,
    selectors: [["ng-component"]],
    inputs: {
      invalid: "invalid",
      light: "light",
      novalidation: "novalidation"
    },
    outputs: {
      onValid: "onValid",
      onInvalid: "onInvalid",
      invalidChange: "invalidChange"
    },
    standalone: false,
    decls: 0,
    vars: 0,
    template: function IDFormBase_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IDFormBase, [{
    type: Component,
    args: [{
      template: ''
    }]
  }], null, {
    invalid: [{
      type: Input
    }],
    light: [{
      type: Input
    }],
    novalidation: [{
      type: Input
    }],
    onValid: [{
      type: Output
    }],
    onInvalid: [{
      type: Output
    }],
    invalidChange: [{
      type: Output
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { IDFormBase, IDIconBase };
